<mat-sidenav-container class="main-container">
  <!-- LEFT SIDEBAR -->
  <mat-sidenav
    mode="over"
    [opened]="!collapsed"
    [style.width]="'280px'"
    class="modern-sidebar"
    (closedStart)="onSidenavClose()">

    <!-- Which school this is, and the way out of the menu. -->
    <div class="sidebar-header-modern">
      <a
        class="brand-container"
        [routerLink]="menuItems[0].route"
        [title]="schoolName"
        (click)="closeMenu()">
        <div class="logo-wrapper">
          <img
            *ngIf="schoolLogo"
            [src]="schoolLogo"
            alt="School photo"
            class="school-initials-badge school-photo-badge" />
          <div *ngIf="!schoolLogo" class="school-initials-badge">
            {{ schoolInitials }}
          </div>
        </div>
        <div class="brand-text">
          <p class="brand-name">{{ schoolName }}</p>
          <p class="brand-tagline">School workspace</p>
        </div>
      </a>

      <button
        mat-icon-button
        (click)="closeMenu()"
        class="close-btn-modern"
        matTooltip="Close menu">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Scrollable Content Wrapper -->
    <div class="sidebar-content-wrapper">
      <!-- Main Navigation -->
      <nav class="navigation-modern" aria-label="Main menu">
        <p class="nav-section-title">Menu</p>

        <div class="nav-group">
          <a
            *ngFor="let item of menuItems"
            [routerLink]="item.route"
            routerLinkActive="active-modern"
            [routerLinkActiveOptions]="{ exact: false }"
            [title]="item.title"
            (click)="navigateToMenuItem(item)"
            class="nav-item-modern">
            <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
            <span class="nav-label">{{ item.label }}</span>

            <!-- How much is waiting on the Notifications page, without opening it. -->
            <ng-container *ngIf="item.route === notificationsPageRoute">
              <span class="nav-count" *ngIf="unreadNotificationCount$ | async as count">{{ count }}</span>
            </ng-container>
          </a>
        </div>
      </nav>

      <!-- Admin Section (Conditional) -->
      <div *ngIf="isAdminUser" class="admin-section-wrapper">
        <div class="section-divider"></div>

        <nav class="navigation-modern admin-nav" aria-label="Administration">
          <button
            type="button"
            class="nav-section-title clickable"
            [attr.aria-expanded]="!hideAdminMenu"
            (click)="toggleAdminMenu()">
            <span>Administration</span>
            <mat-icon class="expand-icon" [class.rotated]="!hideAdminMenu">expand_more</mat-icon>
          </button>

          <div class="nav-group" [class.collapsed]="hideAdminMenu">
            <a
              routerLink="/settings/admin/school-account"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              class="nav-item-modern">
              <mat-icon class="nav-icon">school</mat-icon>
              <span class="nav-label">School Profile</span>
            </a>

            <!-- Admin-only, like the API behind it: where an admin sees why a restriction is not running on a given day. -->
            <a
              routerLink="/school-calendar/overview"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              title="School calendar and restriction exceptions"
              class="nav-item-modern">
              <mat-icon class="nav-icon">event_busy</mat-icon>
              <span class="nav-label">Calendar</span>
            </a>

            <!-- The absences the MIS reported, by day: why a school restriction was cancelled for a pupil. -->
            <a
              routerLink="/school-calendar/student-absences"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              title="Pupil absences reported by your MIS"
              class="nav-item-modern">
              <mat-icon class="nav-icon">person_off</mat-icon>
              <span class="nav-label">Student absences</span>
            </a>

            <!-- Pupils on their own attendance pattern: a standing fact about a pupil, not about a date. -->
            <a
              routerLink="/school-calendar/part-time-pupils"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              title="Pupils on an individual timetable"
              class="nav-item-modern">
              <mat-icon class="nav-icon">schedule</mat-icon>
              <span class="nav-label">Part-time pupils</span>
            </a>

            <a
              routerLink="/settings/admin/mis-integration"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              class="nav-item-modern">
              <mat-icon class="nav-icon">sync</mat-icon>
              <span class="nav-label">MIS Integration</span>
            </a>

            <a
              routerLink="/settings/admin/parent-requests"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              class="nav-item-modern">
              <mat-icon class="nav-icon">pending_actions</mat-icon>
              <span class="nav-label">Parent Requests</span>
            </a>

            <a
              routerLink="/settings/admin/pupil-duplicates"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              class="nav-item-modern">
              <mat-icon class="nav-icon">content_copy</mat-icon>
              <span class="nav-label">Possible duplicates</span>
            </a>

            <a
              routerLink="/settings/admin/system"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              class="nav-item-modern">
              <mat-icon class="nav-icon">tune</mat-icon>
              <span class="nav-label">Settings</span>
            </a>
          </div>
        </nav>
      </div>

      <!-- Help: its own section, after Administration, and open to every role. -->
      <div class="help-section-wrapper">
        <div class="section-divider"></div>

        <nav class="navigation-modern" aria-label="Help">
          <p class="nav-section-title">Help</p>

          <div class="nav-group">
            <!-- Exact, so the Responses page below does not light this one up as well. -->
            <a
              [routerLink]="helpPageRoute"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMenu()"
              title="Help and frequently asked questions"
              class="nav-item-modern">
              <mat-icon class="nav-icon">help_outline</mat-icon>
              <span class="nav-label">Help &amp; FAQ</span>
            </a>

            <a
              [routerLink]="parentResponsesPageRoute"
              routerLinkActive="active-modern"
              [routerLinkActiveOptions]="{ exact: false }"
              (click)="closeMenu()"
              title="What to say to a parent asking about LOQT"
              class="nav-item-modern">
              <mat-icon class="nav-icon">forum</mat-icon>
              <span class="nav-label">Responses to Parents</span>
            </a>

            <!-- Not a page: it opens the same Contact us dialog the help pages offer. -->
            <button
              type="button"
              (click)="openContactUs()"
              title="Email the LOQT team"
              class="nav-item-modern nav-item-button">
              <mat-icon class="nav-icon">mail_outline</mat-icon>
              <span class="nav-label">Contact us</span>
            </button>
          </div>
        </nav>
      </div>
    </div>

    <!-- Footer Branding -->
    <div class="sidebar-footer-modern">
      <img
        src="assets/icons/Loqt_Logotype-06.svg"
        alt="LOQT"
        class="footer-logo" />
    </div>
  </mat-sidenav>

  <!-- MAIN CONTENT AREA -->
  <mat-sidenav-content>
    <mat-toolbar class="modern-toolbar" [color]="null">
      <div class="toolbar-container">
        <div class="toolbar-left">
          <button 
            mat-icon-button 
            (click)="toggleMenu()" 
            aria-label="Open menu"
            class="menu-toggle-button"
            matTooltip="Open menu">
            <mat-icon>menu</mat-icon>
          </button>
            <a [routerLink]="menuItems[0].route"
               routerLinkActive="active-modern"
               [routerLinkActiveOptions]="{ exact: false }">
                <img
                    *ngIf="schoolLogo"
                    [src]="schoolLogo"
                    alt="School photo"
                    class="toolbar-initials-badge school-photo-badge" />
                <div *ngIf="!schoolLogo" class="toolbar-initials-badge">
                    {{ schoolInitials }}
                </div>
            </a>
          <span class="toolbar-title">{{ schoolName }}</span>
        </div>
        
        <div class="toolbar-center">
          <!-- Optional: Add search or navigation items here -->
        </div>
        
        <div class="toolbar-right">
          <button
            mat-icon-button
            class="notification-bell"
            aria-label="Notifications"
            matTooltip="Notifications"
            #notificationTrigger="matMenuTrigger"
            [matMenuTriggerFor]="notificationMenu"
            [matMenuTriggerRestoreFocus]="false">
            <mat-icon
              [matBadge]="unreadNotificationCount$ | async"
              [matBadgeHidden]="(unreadNotificationCount$ | async) === 0"
              matBadgeColor="warn"
              matBadgeSize="small"
              aria-hidden="false">notifications</mat-icon>
          </button>
          <div
            class="user-capsule"
            [matMenuTriggerFor]="userMenu" 
            [matMenuTriggerRestoreFocus]="false">
            <div class="user-status-indicator"></div>
            <div class="user-info">
              <span class="user-name">{{ userName }}</span>
              <span class="user-role">{{ userRole }}</span>
            </div>
            <div class="user-avatar-container">
              <img
                [src]='profileAvatar'
                alt="User Avatar" 
                class="user-avatar" />
              <div class="avatar-ring"></div>
            </div>
            <mat-icon class="dropdown-indicator">expand_more</mat-icon>
          </div>
        </div>
      </div>
    </mat-toolbar>
    
    <mat-menu #notificationMenu="matMenu" class="notification-menu" xPosition="before">
      <ng-container *ngIf="unreadNotifications$ | async as notifications">
        <div class="notification-header" (click)="$event.stopPropagation()">
          <span class="notification-header-title">Notifications</span>
          <button
            mat-button
            class="notification-mark-all"
            [disabled]="notifications.length === 0"
            (click)="markAllNotificationsRead()">
            Mark all as read
          </button>
        </div>
        <div class="notification-list" (click)="$event.stopPropagation()">
          <div *ngIf="notifications.length === 0" class="notification-empty">
            You are all caught up. Older notices are on the Notifications page.
          </div>
          <app-notification-item
            *ngFor="let notification of notifications"
            [notification]="notification"
            (open)="openNotification(notification); notificationTrigger.closeMenu()">
          </app-notification-item>
        </div>
        <div class="notification-footer">
          <button mat-button class="notification-see-all" [routerLink]="notificationsPageRoute">
            See all notifications
          </button>
        </div>
      </ng-container>
    </mat-menu>

    <mat-menu #userMenu="matMenu" class="modern-user-menu">
      <div class="user-menu-header">
        <img 
          [src]='profileAvatar'
          alt="User Avatar" 
          class="menu-avatar" />
        <div class="menu-user-info">
          <span class="menu-user-name">{{ userName || 'User' }}</span>
          <span class="menu-user-email">{{ userEmail || 'user@school.edu' }}</span>
        </div>
      </div>
      
      <div class="menu-section">
        <button 
          mat-menu-item 
          (click)="navigateTo('/settings/user/profile', 'User Profile Settings')" 
          class="menu-item-modern">
          <mat-icon class="menu-icon">account_circle</mat-icon>
          <span>My Profile</span>
        </button>

      </div>
      
      <mat-divider class="menu-divider"></mat-divider>
      
      <button mat-menu-item class="logout-button" (click)="confirmLogout()">
        <mat-icon class="menu-icon">power_settings_new</mat-icon>
        <span>Sign Out</span>
      </button>
    </mat-menu>

    <!-- Storage / session resilience nudge -->
    <div class="storage-nudge" *ngIf="nudge && !nudgeDismissed" role="status">
      <mat-icon class="storage-nudge__icon">{{ nudge === 'storage-disabled' ? 'warning_amber' : 'info' }}</mat-icon>
      <span class="storage-nudge__text">
        <ng-container *ngIf="nudge === 'storage-disabled'">
          Cookies or browser storage are turned off. Please enable localStorage and cookies so your
          session can be saved — otherwise you'll be signed out when you reload.
        </ng-container>
        <ng-container *ngIf="nudge === 'ids-missing'">
          Your session details are missing — they may have been cleared. Refresh to restore them, or sign in again.
        </ng-container>
      </span>
      <button *ngIf="nudge === 'ids-missing'" mat-button color="primary" (click)="onNudgeRefresh()">Refresh</button>
      <button *ngIf="nudge === 'ids-missing'" mat-button (click)="onNudgeSignIn()">Sign in again</button>
      <button mat-icon-button aria-label="Dismiss" (click)="dismissNudge()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Page Content -->
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>